/**
 * WCAG Accessibility Testing Utility
 * Runs automated accessibility audits using axe-core
 * Only runs in development mode
 */

import React from 'react';

// Initialize axe-core for development accessibility testing
export const initAccessibilityTesting = () => {
  if (process.env.NODE_ENV !== 'production') {
    import('@axe-core/react').then((axe) => {
      import('react-dom').then((ReactDOM) => {
        axe.default(React, ReactDOM, 1000, {
          // WCAG 2.1 AA compliance rules
          runOnly: {
            type: 'tag',
            values: ['wcag2a', 'wcag2aa', 'wcag21a', 'wcag21aa', 'best-practice']
          },
          // Rules configuration
          rules: [
            // Color contrast
            { id: 'color-contrast', enabled: true },
            // Form labels
            { id: 'label', enabled: true },
            // Image alt text
            { id: 'image-alt', enabled: true },
            // Link text
            { id: 'link-name', enabled: true },
            // Button text
            { id: 'button-name', enabled: true },
            // Heading order
            { id: 'heading-order', enabled: true },
            // Document title
            { id: 'document-title', enabled: true },
            // HTML lang attribute
            { id: 'html-has-lang', enabled: true },
            // Valid lang attribute
            { id: 'html-lang-valid', enabled: true },
            // Bypass blocks (skip links)
            { id: 'bypass', enabled: true },
            // Focus order
            { id: 'focus-order-semantics', enabled: true },
            // Video captions
            { id: 'video-caption', enabled: true },
            // ARIA landmarks
            { id: 'region', enabled: true },
          ]
        }).then(() => {
          console.log('%c[A11Y] Accessibility testing initialized', 'color: #84cc16; font-weight: bold');
        });
      });
    }).catch((error) => {
      console.warn('Accessibility testing could not be initialized:', error);
    });
  }
};

// Accessibility report component for development
export const AccessibilityReport = ({ violations = [] }) => {
  if (process.env.NODE_ENV === 'production' || violations.length === 0) {
    return null;
  }

  return (
    <div 
      className="fixed bottom-4 left-4 z-50 max-w-md bg-red-900 text-white p-4 rounded-lg shadow-xl"
      role="alert"
      aria-live="polite"
    >
      <h3 className="font-bold text-lg mb-2">⚠️ Accessibility Issues ({violations.length})</h3>
      <ul className="text-sm space-y-1 max-h-48 overflow-y-auto">
        {violations.map((violation, index) => (
          <li key={index} className="border-b border-red-700 pb-1">
            <strong>{violation.id}</strong>: {violation.description}
            <span className="text-red-300 text-xs block">Impact: {violation.impact}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default initAccessibilityTesting;
